// Navigation
export var GET_SECTIONS = "GET_SECTIONS";
export var GET_SECTIONS_SUCCESS = "GET_SECTIONS_SUCCESS";
export var GET_SECTIONS_ERROR = "GET_SECTIONS_ERROR";
export var SET_SECTION = "SET_SECTION";
export var GET_SECTION = "GET_SECTION";
export var GET_SECTION_SUCCESS = "GET_SECTION_SUCCESS";
export var GET_SECTION_ERROR = "GET_SECTION_ERROR";
export var SET_LAST_SEEN = "SET_LAST_SEEN";

export var GET_SPECIAL_FEATURES = "GET_SPECIAL_FEATURES";
export var GET_SPECIAL_FEATURES_SUCCESS = "GET_SPECIAL_FEATURES_SUCCESS";
export var GET_SPECIAL_FEATURES_ERROR = "GET_SPECIAL_FEATURES_ERROR";

// Tag
export var GET_TAG = "GET_TAG";
export var GET_TAG_ERROR = "GET_TAG_ERROR";

// Auth Drawer
export var AUTH_DRAWER_OPEN = "AUTH_DRAWER_OPEN";
export var CHANGE_STEP = "CHANGE_STEP";

export var EMAIL_NOT_AVAILABLE = "EMAIL_NOT_AVAILABLE";
export var EMAIL_AVAILABLE = "EMAIL_AVAILABLE";
export var EMAIL_VALIDATION_REQUEST_ERROR = "EMAIL_VALIDATION_REQUEST_ERROR";

export var EMAIL_CONFIRM_SUCCESS = "EMAIL_CONFIRM_SUCCESS";
export var EMAIL_CONFIRM_ERROR = "EMAIL_CONFIRM_ERROR";

export var SET_BASIC_INFO = "SET_BASIC_INFO";
export var SET_OPTIONAL_INFO = "SET_OPTIONAL_INFO";

export var CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export var CREATE_USER_ERROR = "CREATE_USER_ERROR";

export var PASSWORD_RESET_REQUEST_SUCCESS = "PASSWORD_RESET_REQUEST_SUCCESS";
export var PASSWORD_RESET_REQUEST_ERROR = "PASSWORD_RESET_REQUEST_ERROR";
export var SET_PASSWORD_RESET_INFO = "SET_PASSWORD_RESET_INFO";
export var PASSWORD_RESET_SUCCESS = "PASSWORD_RESET_SUCCESS";
export var PASSWORD_RESET_ERROR = "PASSWORD_RESET_ERROR";

export var SET_AUTH_TOKEN = "SET_AUTH_TOKEN";
export var LOG_OUT = "LOG_OUT";

export var LOGGED_IN_STATUS = "LOGGED_IN_STATUS";

// Trending
export var GET_TRENDING_TOPICS_SUCCESS = "GET_TRENDING_TOPICS_SUCCESS";
export var GET_TRENDING_TOPICS_ERROR = "GET_TRENDING_TOPICS_ERROR";
export var TOGGLE_OFFSET = "TOGGLE_OFFSET";

// Latest
export var GET_LATEST_STORIES = "GET_LATEST_STORIES";
export var GET_LATEST_STORIES_SUCCESS = "GET_LATEST_STORIES_SUCCESS";
export var GET_LATEST_STORIES_ERROR = "GET_LATEST_STORIES_ERROR";

// Stream
export var GET_STORIES_STREAM = "GET_STORIES_STREAM";
export var GET_STORIES_STREAM_SUCCESS = "GET_STORIES_STREAM_SUCCESS";
export var GET_STORIES_STREAM_UPDATE = "GET_STORIES_STREAM_UPDATE";
export var GET_STORIES_STREAM_ERROR = "GET_STORIES_STREAM_ERROR";
export var RESET_STORIES_STREAM_ERROR = "RESET_STORIES_STREAM_ERROR";
export var SET_STORY_STREAM = "SET_STORY_STREAM";

// Story
export var GET_STORY = "GET_STORY";
export var GET_STORY_SUCCESS = "GET_STORY_SUCCESS";
export var GET_STORY_UPDATE = "GET_STORY_UPDATE";
export var GET_STORY_ERROR = "GET_STORY_ERROR";

// Author
export var GET_AUTHOR = "GET_AUTHOR";
export var GET_AUTHOR_SUCCESS = "GET_AUTHOR_SUCCESS";
export var GET_AUTHOR_ERROR = "GET_AUTHOR_ERROR";

// Subscription
export var GET_SUBSCRIPTION = "GET_SUBSCRIPTION";
export var GET_SUBSCRIPTION_SUCCESS = "GET_SUBSCRIPTION_SUCCESS";
export var GET_SUBSCRIPTION_ERROR = "GET_SUBSCRIPTION_ERROR";

// Subscriptions
export var GET_SUBSCRIPTIONS = "GET_SUBSCRIPTIONS";
export var GET_SUBSCRIPTIONS_SUCCESS = "GET_SUBSCRIPTIONS_SUCCESS";
export var GET_SUBSCRIPTIONS_ERROR = "GET_SUBSCRIPTIONS_ERROR";

// Subscription Newsletters
export var GET_SUBSCRIPTION_NEWSLETTERS = "GET_SUBSCRIPTION_NEWSLETTERS";
export var GET_SUBSCRIPTION_NEWSLETTERS_SUCCESS = "GET_SUBSCRIPTION_NEWSLETTERS_SUCCESS";
export var GET_SUBSCRIPTION_NEWSLETTERS_ERROR = "GET_SUBSCRIPTION_NEWSLETTERS_ERROR";

// Newsletter
export var GET_NEWSLETTER = "GET_NEWSLETTER";
export var GET_NEWSLETTER_SUCCESS = "GET_NEWSLETTER_SUCCESS";
export var GET_NEWSLETTER_ERROR = "GET_NEWSLETTER_ERROR";

// Newsletters
export var GET_NEWSLETTERS = "GET_NEWSLETTERS";
export var GET_NEWSLETTERS_SUCCESS = "GET_NEWSLETTERS_SUCCESS";
export var GET_NEWSLETTERS_ERROR = "GET_NEWSLETTERS_ERROR";

// Search
export var GET_SEARCH_RESULTS = "GET_SEARCH_RESULTS";
export var GET_SEARCH_RESULTS_SUCCESS = "GET_SEARCH_RESULTS_SUCCESS";
export var GET_SEARCH_RESULTS_UPDATE = "GET_SEARCH_RESULTS_UPDATE";
export var GET_SEARCH_RESULTS_ERROR = "GET_SEARCH_RESULTS_ERROR";

// User Settings
export var GET_USER_DATA = "GET_USER_DATA";
export var GET_USER_DATA_SUCCESS = "GET_USER_DATA_SUCCESS";
export var GET_USER_DATA_ERROR = "GET_USER_DATA_ERROR";

export var TYPING_USER_SETTINGS = "TYPING_USER_SETTINGS";
export var SUBMIT_USER_SETTINGS = "SUBMIT_USER_SETTINGS";
export var SUBMIT_USER_SETTINGS_SUCCESS = "SUBMIT_USER_SETTINGS_SUCCESS";
export var SUBMIT_USER_SETTINGS_ERROR = "SUBMIT_USER_SETTINGS_ERROR";

export var GET_USER_SUBSCRIPTIONS = "GET_USER_SUBSCRIPTIONS";
export var GET_USER_SUBSCRIPTIONS_SUCCESS = "GET_USER_SUBSCRIPTIONS_SUCCESS";
export var GET_USER_SUBSCRIPTIONS_ERROR = "GET_USER_SUBSCRIPTIONS_ERROR";
export var CHANGE_USER_SUBSCRIPTIONS = "CHANGE_USER_SUBSCRIPTIONS";
export var SUBMIT_USER_SUBSCRIPTIONS = "SUBMIT_USER_SUBSCRIPTIONS";
export var SUBMIT_USER_SUBSCRIPTIONS_SUCCESS = "SUBMIT_USER_SUBSCRIPTIONS_SUCCESS";
export var SUBMIT_USER_SUBSCRIPTIONS_ERROR = "SUBMIT_USER_SUBSCRIPTIONS_ERROR";

export var SUBMIT_USER_SAVED_STORIES = "SUBMIT_USER_SAVED_STORIES";
export var SUBMIT_USER_SAVED_STORIES_SUCCESS = "SUBMIT_USER_SAVED_STORIES_SUCCESS";
export var SUBMIT_USER_SAVED_STORIES_ERROR = "SUBMIT_USER_SAVED_STORIES_ERROR";

export var DELETE_ACCOUNT = "DELETE_ACCOUNT";
export var DELETE_ACCOUNT_SUCCESS = "DELETE_ACCOUNT_SUCCESS";
export var DELETE_ACCOUNT_ERROR = "DELETE_ACCOUNT_ERROR";

export var CHANGE_PASSWORD = "CHANGE_PASSWORD";
export var CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export var CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR";

// Unauthed Subscriptions
export var SET_UNAUTHED_SUBSCRIPTIONS = "SET_UNAUTHED_SUBSCRIPTIONS";
export var SET_UNAUTHED_SUBSCRIPTIONS_SUCCESS = "SET_UNAUTHED_SUBSCRIPTIONS_SUCCESS";
export var SET_UNAUTHED_SUBSCRIPTIONS_ERROR = "SET_UNAUTHED_SUBSCRIPTIONS_ERROR";

// User Subscriptions
export var UPDATE_USER_SUBSCRIPTIONS = "UPDATE_USER_SUBSCRIPTIONS";
export var UPDATE_USER_SUBSCRIPTIONS_SUCCESS = "UPDATE_USER_SUBSCRIPTIONS_SUCCESS";
export var UPDATE_USER_SUBSCRIPTIONS_ERROR = "UPDATE_USER_SUBSCRIPTIONS_ERROR";

// Events
export var GET_EVENTS = "GET_EVENTS";
export var GET_EVENTS_SUCCESS = "GET_EVENTS_SUCCESS";
export var GET_EVENTS_ERROR = "GET_EVENTS_ERROR";


// WEBPACK FOOTER //
// ./src/constants/actionTypes.js